export const countryGeometries: { [key: string]: [number, number] } = {
  UZ: [41.31119825, 69.27975936],
  KZ: [51.169392, 71.449074],
};

export const ORDER_TYPE_IDS: { [key: string]: string } = {
  selfPickup: '6d9f3d3b-c385-4fed-8273-8f213b82ffef',
  delivery: '04735eda-6180-477d-93ac-30dfb3c35007',
  hall: 'cfcb3fa9-c6d3-4ab3-8874-22359ffec821',
};
